import DashboardResultsItem from "./DashboardResultsItem";

export default DashboardResultsItem;